import React from 'react';

import BattlePlanSelector from '@/components/BattlePlanSelector';

export default function PhoneIndex() {
  return (
    <BattlePlanSelector 
      routeType="phone" 
      title="Phone Campaigns"
      battlePlanTypeFilter="phonebanking,gotv-phoning"
    />
  );
}
